import { render } from "./vinvitemember.vue?vue&type=template&id=1dbe2ae0&scoped=true"
import script from "./vinvitemember.vue?vue&type=script&lang=js"
export * from "./vinvitemember.vue?vue&type=script&lang=js"

import "./vinvitemember.vue?vue&type=style&index=0&id=1dbe2ae0&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbe2ae0"]])

export default __exports__